import { useSelector } from "react-redux";
import { SearchGen } from "../SearchGen";
import { useLocation, useNavigate } from "react-router-dom";
import { stringMin } from "../../core/function/function-generic";
import iconuser from "./../../static/images/user-pp.png"
interface HeaderGenProps {
    onSearchGen?: string;
}

export const HeaderGen: React.FC<HeaderGenProps> = (props) => {
    const { onSearchGen } = props;
    const business = useSelector((state: any) => state.business);
    const location = useLocation();
    const navigate = useNavigate();
    /*     const onSearchGen = (e) => {
            console.log(e.target.value)
        } */

    return (
        <header className="py-[22px]">
            <div className="flex justify-between items-center">
                <div>Overview</div>
                <div
                    className={`flex`}
                >
                    {/*                     <div className="flex">
                        <div>
                            {
                                ['/withdrawal'].includes(location.pathname) && <SearchGen onSearchGen={onSearchGen} />
                            }
                        </div>
                    </div> */}
                    <div className={`flex items-center p-1 cursor-pointer ${['/profile'].includes(location.pathname) ? 'profile-active' : ''}`}>
                        <div className="">
                            <img
                                onClick={() => navigate('/profile')}
                                className="inline-block h-9 w-9 rounded-full"
                                src={iconuser}
                                alt=""
                            />
                        </div>
                        <div className={`p-1`} id="profile-id" onClick={() => navigate('/profile')}>
                            <p className="header-user">{business.name}</p>
                            <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">{stringMin(business.role)}</p>
                        </div>
                    </div>
                </div>

            </div>
        </header>
    )
}